<div mat-dialog-title class="header">
  <div class="font-headline-4 color-feedback-error-error">
    {{ 'keep-session-open-dialog.title' | translate }}
  </div>
</div>
<div mat-dialog-content class="content d-flex flex-column align-items-center flex-gap-1">
  <div class="align-self-start">{{ 'keep-session-open-dialog.information' | translate }}</div>
  <div>
    <mat-progress-spinner
      color="primary"
      diameter="60"
      mode="determinate"
      strokeWidth="5"
      [value]="spinnerValue"
    ></mat-progress-spinner>
    <div class="timer-count-container">
      <span>{{ timerCount }}s</span>
    </div>
  </div>
</div>
<div mat-dialog-actions class="buttons-list">
  <button
    type="button"
    mat-flat-button
    class="font-button color-feedback-action-action button-fixed-height"
    (click)="deny()"
    cdkFocusInitial
  >
    <span class="btn-text">{{ 'keep-session-open-dialog.buttons.sign-out' | translate }}</span>
  </button>
  <button
    type="button"
    mat-flat-button
    color="primary"
    class="button-primary font-button button-action-detail button-fixed-height"
    (click)="confirm()"
  >
    <span class="btn-text">{{
      'keep-session-open-dialog.buttons.keep-me-logged-in' | translate
    }}</span>
  </button>
</div>
